import { getMessaging, getToken, isSupported } from 'firebase/messaging';
import { doc, setDoc } from 'firebase/firestore';
import { app, db } from './firebase';

/**
 * Registers this browser/device for staff push notifications
 * (new bookings & quote requests). Requires the Web Push (VAPID) key
 * from the Firebase console, stored in site settings.
 */
export async function enablePushOnThisDevice(vapidKey: string): Promise<void> {
  if (!vapidKey.trim()) throw new Error('Paste your Web Push key first (see instructions below).');
  if (!(await isSupported())) throw new Error("This browser doesn't support push notifications.");

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Notifications are blocked — allow them for this site in your browser settings.');
  }

  const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
  const token = await getToken(getMessaging(app()), {
    vapidKey: vapidKey.trim(),
    serviceWorkerRegistration: registration,
  });
  if (!token) throw new Error("Couldn't get a push token — try again.");

  await setDoc(doc(db(), 'fcmTokens', token), {
    createdAt: Date.now(),
    userAgent: navigator.userAgent.slice(0, 200),
  });
}
